import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import cn from 'classnames';

const useStyles = makeStyles(theme => ({
    root: {
        textDecorationLine: 'underline',
        // textDecorationStyle: 'solid',
        color: props => props.color,
        cursor: 'pointer',
    },
}));

export default function InlineTextButton(props) {
    const classes = useStyles(props);
    const { className: propsClass, ...other } = props;

    return (
        <span className={cn(classes.root, propsClass)} {...other} />
    );
}